import vue from "vue";
import vuex from "vuex";
import Base from "./modules/base.module";
import Hotel from "./modules/hotel.module";
import Flight from "./modules/flight.module";
import Passenger from "./modules/passenger.module";
import Book from "./modules/book.module";
import baseModule from "../../../store/baseInfo";
import profile from "../../profile/store/profile";
import unauthorized from "./modules/unauthorized.module";
import authentication from '../../../store/authentication';
import club from '../../club/store/club'

vue.use(vuex);

export default new vuex.Store({
  modules: {
    Base,
    Hotel,
    Flight,
    Passenger,
    Book,
    baseModule,
    profile,
    unauthorized,
    authentication,
    club
  }
});
